import CultureCodeEnum from '../../../../models/culture-code-enum';
import { FavouriteBasketType } from '../../../../models/favourite-basket-type';
import client from '../../client';

const favouritesAll = async (parameters?: {
  query?: string;
}): Promise<FavouriteBasketType[]> => {
  const { data } = await client.get<FavouriteBasketType[]>('/favourites/all', {
    params: {
      cultureCode: CultureCodeEnum.EnGb,
      query: parameters?.query ?? '',
    },
  });

  return data;
};

export default favouritesAll;
